import React, { useState, useEffect, useCallback, useRef } from "react";
import { Col, Select, Row } from "antd";
import { levels1, levels2 } from "./config.js";
import UserModal from "@components/userModal";
import { connect } from "react-redux";
import "./index.less";
import TestWizardModal from "@components/testWizardModal";
const SIGNUP_MODAL = " 2";
const { Option } = Select;
const SELECT_LONG_CLASS = 1;
const SELECT_SPECIAL_CLASS = 2;

const SIGNIN_MODAL = "1";
const STATE_NOT_START = 0;
const STATE_STARTED = 1;
const STATE_END = 2;
const STATE_FAILED = 3;
const wxSigninUrl = "/weixin/signin";
const wxSignupUrl = "/weixin/signup";
const SHOW_WIZARD = "showTestWizard";
const loadUrl = "/json/evaluate/status";

const entryUrl = "/evaluate/entry";
const testUrl = "/evaluate/paper";
// reportUrl : '/evaluate/report',
const reportUrl = "/evaluate/report";

function LevelIntro(props) {
  const userModal = useRef();
  const testModalRef = useRef();
  const { userInfo, igtInfo } = props;
  const [url, setUrl] = useState();

  const [duanList, setDuanList] = useState(levels1["北京"]);
  const [curTab, setCurTab] = useState(SELECT_LONG_CLASS);
  const backTop = () => {
    document.getElementById("root").scrollTo({
      left: 0,
      top: 0,
      behavior: "smooth",
    });
  };
  const experienceNow = () => {
    if (igtInfo && !igtInfo.Paid) {
      if (igtInfo.Status == STATE_END || igtInfo.Status == STATE_FAILED) {
        return;
      } else {
        setUrl(getLocation(igtInfo.Status, igtInfo.IGTStatus));
        testModalRef.current.showModal();
        return;
      }
    }
    if (userInfo) {
      window.location = userInfo.Group == 0 ? "/home" : "/home_t";
    } else {
      userModal.current.showModal(SIGNUP_MODAL);
    }
  };
  const handleChange = (val) => {
    setDuanHandler(val);
  };
  const setDuanHandler = useCallback(
    (val) => {
      const defaultVal = "北京";
      if (val === undefined) {
        val = defaultVal;
      }
      if (curTab === SELECT_LONG_CLASS) {
        setDuanList(levels1[val]);
      } else if (curTab === SELECT_SPECIAL_CLASS) {
        setDuanList(levels2[val]);
      }
    },
    [curTab]
  );
  const tabToggle = (tabIdx) => {
    setCurTab(tabIdx);
    // eslint-disable-next-line no-undef
    zhuge.track("level_intro_class_choose_ver3", {
      班型: tabIdx === SELECT_LONG_CLASS ? "长期班" : "专项课",
    });
    setDuanHandler();
  };
  const getLocation = (status, IGTStatus) => {
    if (status == STATE_NOT_START) {
      return entryUrl;
    } else if (status == STATE_STARTED) {
      return testUrl;
    } else if (status == STATE_END || IGTStatus == 2) {
      // 测试异常，但已定级也显示段位
      // me.data.Status = 2
      return reportUrl;
    } else if (status == STATE_FAILED) {
      return entryUrl;
    }
  };
  useEffect(() => {
    setDuanHandler();
  }, [curTab, setDuanHandler]);
  useEffect(() => {
    // eslint-disable-next-line no-undef
    zhuge.track("level_intro_entry_ver3");
  }, []);
  return (
    <div id="levelIntro-wrapper" className="levelIntro-wrapper" >
      <UserModal ref={userModal} />
      {igtInfo ? (
        <TestWizardModal ref={testModalRef} type={0} state={igtInfo.Status} url={url} />
      ) : null}
      <div className="banner-wrapper clearfix">
        <div className="txt-area">
          <h2>爱棋道学习体系介绍</h2>
          <p>
            <span>全面规划您的涨棋之路</span>
          </p>
          <div onClick={experienceNow} className="level-button button-red trial-btn">
            立即体验
          </div>
        </div>
      </div>

      <div className="section why">
        <div className="container">
          <p>
            在十多年的教学实践中，爱棋道的职业棋手教研团队深入研究了诸多普遍的围棋学习问题，并由此推出了爱棋道学习体系（包含十二级课程体系和LPE训练法），以便帮助广大学员全面解决
            “缺乏系统教材”、“知识点如何由浅入深”、“理论如何指导实践”等等痛点问题。
          </p>
          <div className="line line-1"></div>
          <h4 className="sub-title">
            <span>爱棋道学习体系的主要特点</span>
          </h4>
        </div>
        <div className="level-show">
          <ul className="feature-wrapper">
            <Col xs={12} md={12} lg={12} xl={6} style={{ padding: "10px" }}>
              <div className="feature-item">
                <img className="img-responsive" src="/static/img/promotion/item-1.png" alt="item" />
                <div className="icon-box">
                  <img src="/static/img/promotion/icon-1.png" alt="icon" />
                </div>
                <h4>水平全覆盖</h4>
                <p>从启蒙到高段，中国围棋协会段级位地域全覆盖</p>
              </div>
            </Col>
            <Col xs={12} md={12} lg={12} xl={6} style={{ padding: "10px" }}>
              <div className="feature-item">
                <img
                  className="img-responsive"
                  src="/static/img/promotion/item-2.png"
                  alt="item-2"
                />
                <div className="icon-box">
                  <img src="/static/img/promotion/icon-2.png" alt="icon-2" />
                </div>
                <h4>知识点系统编排</h4>
                <p>2000+知识点按水平，专项分类、由浅入深组合搭配</p>
              </div>
            </Col>
            <Col xs={12} md={12} lg={12} xl={6} style={{ padding: "10px" }}>
              <div className="feature-item">
                <img
                  className="img-responsive"
                  src="/static/img/promotion/item-3.png"
                  alt="item-3"
                />
                <div className="icon-box">
                  <img src="/static/img/promotion/icon-3.png" alt="icon-3" />
                </div>
                <h4>效果检验科学</h4>
                <p>设计“预习、复习、月测”等环节，直接与所学知识点相关，即时检验学习效果</p>
              </div>
            </Col>
            <Col xs={12} md={12} lg={12} xl={6} style={{ padding: "10px" }}>
              <div className="feature-item">
                <img
                  className="img-responsive"
                  src="/static/img/promotion/item-4.png"
                  alt="item-4"
                />
                <div className="icon-box">
                  <img src="/static/img/promotion/icon-4.png" alt="icon-4" />
                </div>
                <h4>学习进步量化</h4>
                <p>所有练习、测试环节，都以试卷分数量化呈现，进步细节清晰可见</p>
              </div>
            </Col>
          </ul>
        </div>
      </div>

      <div className="section what">
        <h3 className="section-title">
          什么是<span>爱棋道学习体系</span>
        </h3>
        <div className="level-box">
          <p>
            爱棋道学习体系分为五大阶段十二个<span className="space"></span>{" "}
            级别，并对每个级别进行了详尽科学的学习规划。
            2016年上线至今，爱棋道使用此体系帮助数万名学员快速提升棋力。
          </p>
          <div className="icon1">
            <img
              className="img-responsive"
              src="/static/img/promotion/xunzhang.png"
              alt="xunzhang"
            />
          </div>
        </div>
      </div>

      <div className="section ladder" style={{padding: '0 15px'}}>
        <img src="/static/img/promotion/training.png" alt="hero-img" className="hero-img " />
        <h3 className="section-title">
          重点知识点<span>展示</span>
        </h3>
        <img src="/static/img/promotion/keyknowledge.png" alt="tu_10" className="hero-img2" />
      </div>

      <div className="section what lpe cyan">
        <h3 className="section-title">
          什么是<span>LPE训练法</span>
        </h3>
        <div className="level-box">
          <p>
            LPE训练法俗称“一学二练三做题”，&nbsp;&nbsp;&nbsp;&nbsp;<span className="space"></span>
            是爱棋道经过老师们多年的实战教学经验和数万学员海量学习数据积累，沉淀总结出来的科学学习围棋的训练方法。通过这套方法我们帮助无数的小朋友顺利升级升段。每学期均有80%以上的小朋友通过在爱棋道的学习成功升级升段。
          </p>
          <div className="icon1">
            <img className="img-responsive" src="/static/img/promotion/girl.png" alt="girl" />
          </div>
        </div>

        <h3 className="section-title">
          <span>LPE训练法</span>具体包括哪些？
        </h3>

        <div className="container flex">
          <Row gutter={[24, 16]}>
            <Col xs={24} sm={8}>
              <div className="card learn" style={{ width: "auto" }}>
                <h2>L</h2>
                <h3>Learning</h3>
                <p>
                  “学”，也就是第一步的知识输入，其中包括体系化的课程、优质的主讲老师、在线互动课堂、无限次回放等教研与技术体系。
                </p>
              </div>
            </Col>
            <Col xs={24} sm={8}>
              <div className="card practice" style={{ width: "auto" }}>
                <h2>P</h2>
                <h3>Practice</h3>
                <p>
                  “练”，包括线上人机对弈、人人对弈，人机对弈指的是智能AI对弈（悟空对弈）和AI点评（悟空点评），在爱棋道平台上完成，线上人人对弈由各班级实战老师组织或小朋友们自行组织。
                </p>
              </div>
            </Col>
            <Col xs={24} sm={8}>
              <div className="card exercise" style={{ width: "auto" }}>
                <h2>E</h2>
                <h3>Exercise</h3>
                <p>“做题”，智能题库系统，包含预习题、课后题、死活训练题、自我训练、错题本。</p>
              </div>
            </Col>
          </Row>
        </div>

        <h5 className="title-tip">LPE训练法是循序渐进的闭环学习</h5>
        <img
          src="/static/img/promotion/lpe.png"
          alt="tu_10"
          className="img-responsive level-show initialized"
          style={{ width: "80%" }}
        />
      </div>

      <div className="section">
        <h3 className="section-title">
          如何<span>合理规划涨棋路径</span>
        </h3>
        <div className="line line-2"></div>
        <h4 className="section-subtitle">
          <span>1&nbsp;.选择适合自己的班级</span>
        </h4>
        <div>
          <ul className="nav nav-pills" role="tablist" id="keyknowledge-tabs">
            <li
              className={curTab === SELECT_LONG_CLASS ? "active" : undefined}
              onClick={() => {
                tabToggle(SELECT_LONG_CLASS);
              }}
            >
              <span>长期班</span>
            </li>
            <li
              className={curTab === SELECT_SPECIAL_CLASS ? "active" : undefined}
              onClick={() => {
                tabToggle(SELECT_SPECIAL_CLASS);
              }}
            >
              <span>专项课</span>
            </li>
          </ul>

          <div className="tab-content">
            {curTab === SELECT_LONG_CLASS ? (
              <div role="tabpanel" className="tab-pane active" id="longTerm">
                <div className="x-scroll">
                  <table className="level-table table table-bordered">
                    <thead>
                      <tr>
                        <th className="yl-font"></th>
                        <th className="yl-font"></th>
                        <th colspan="2" className="yl-font">
                          启蒙阶段
                        </th>
                        <th colSpan="2" className="yl-font">
                          基础阶段
                        </th>
                        <th colspan="3" className="yl-font">
                          初级阶段
                        </th>
                        <th colspan="3" className="yl-font">
                          中级阶段
                        </th>
                        <th colspan="2" className="yl-font">
                          高级阶段
                        </th>
                        <th colspan="2" className="yl-font">
                          专业阶段
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td></td>
                        <td className="yl-font">长期班班型</td>
                        <td>启蒙零基础</td>
                        <td>启蒙进阶突破</td>
                        <td>I-1长期班</td>
                        <td>I-2长期班</td>
                        <td>I-3长期班</td>
                        <td>I-4长期班</td>
                        <td>I-5长期班</td>
                        <td>I-6长期班</td>
                        <td>I-7长期班</td>
                        <td>I-8长期班</td>
                        <td>I-9长期班</td>
                        <td>I-10长期班</td>
                        <td>特战二队</td>
                        <td>特战一队</td>
                      </tr>
                      <tr>
                        <td rowspan="3" className="yl-font">
                          <div className="col1 max20">在线平台级别</div>
                        </td>
                        <td className="yl-font">弈城级别</td>
                        <td>-</td>
                        <td>-</td>
                        <td>18K-17K</td>
                        <td>16K-15K</td>
                        <td>15K-11K</td>
                        <td>10K-6K</td>
                        <td>5K-1K</td>
                        <td>1D</td>
                        <td>2D</td>
                        <td>3D</td>
                        <td>4D</td>
                        <td>5D</td>
                        <td>6D-7D</td>
                        <td>7D-9D</td>
                      </tr>
                      <tr>
                        <td className="yl-font">野狐级别</td>
                        <td>-</td>
                        <td>-</td>
                        <td>18K-17K</td>
                        <td>16K-14K</td>
                        <td>13K-10K</td>
                        <td>9K-5K</td>
                        <td>4K-1D</td>
                        <td>1D-2D</td>
                        <td>3D</td>
                        <td>4D</td>
                        <td>5D</td>
                        <td>5D-6D</td>
                        <td>6D-7D</td>
                        <td>7D-9D</td>
                      </tr>
                      <tr>
                        <td className="yl-font">新博级别</td>
                        <td>零起点-23K</td>
                        <td>22K-15K</td>
                        <td>15K-8K</td>
                        <td>8K-4K</td>
                        <td>4K-1K</td>
                        <td>1D</td>
                        <td>2D</td>
                        <td>3D-4D</td>
                        <td>5D</td>
                        <td>6D</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                      </tr>
                      <tr>
                        <td className="yl-font">
                          <div className="col1 max40">主要地区比赛级别</div>
                        </td>
                        <td className="yl-font">
                          <Select
                            defaultValue={"北京"}
                            style={{ width: 120 }}
                            onChange={handleChange}
                          >
                            {Object.keys(levels1).map((key) => {
                              return <Option value={key}>{key}</Option>;
                            })}
                          </Select>
                        </td>
                        {duanList.map((val, idx) => {
                          return <td>{val}</td>;
                        })}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ) : null}
            {curTab === SELECT_SPECIAL_CLASS ? (
              <div role="tabpanel" className="tab-pane " id="specialTerm">
                <div className="x-scroll">
                  <table className="level-table table table-bordered">
                    <thead>
                      <tr>
                        <th className="yl-font"></th>
                        <th className="yl-font"></th>
                        <th className="yl-font">I-3~I-4 定式布局/中盘实战专项班</th>
                        <th className="yl-font">I-5~I-6 定式布局/中盘实战专项班</th>
                        <th className="yl-font">I-7~I-8 定式布局/中盘实战专项班</th>
                        <th className="yl-font">I-9~I-10 定式布局/中盘实战专项班</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowspan="3" className="yl-font">
                          <div className="col1 max20">在线平台级别</div>
                        </td>
                        <td className="yl-font">弈城级别</td>
                        <td>15K~7K</td>
                        <td>6K-1D</td>
                        <td>2D-3D</td>
                        <td>4D-5D</td>
                      </tr>
                      <tr>
                        <td className="yl-font">野狐级别</td>
                        <td>15k~5K</td>
                        <td>4K-2D</td>
                        <td>3D-4D</td>
                        <td>5D-6D</td>
                      </tr>
                      <tr>
                        <td className="yl-font">新博级别</td>
                        <td>4K-1D</td>
                        <td>1D-4D</td>
                        <td>4D-5D</td>
                        <td>6D</td>
                      </tr>
                      <tr>
                        <td className="yl-font">
                          <div className="col1 max40">主要地区比赛级别</div>
                        </td>
                        <td className="yl-font">
                          <Select
                            defaultValue={"北京"}
                            style={{ width: 120 }}
                            onChange={handleChange}
                          >
                            {Object.keys(levels2).map((key) => {
                              return <Option value={key}>{key}</Option>;
                            })}
                          </Select>
                        </td>
                        {duanList.map((val, idx) => {
                          return <td>{val}</td>;
                        })}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <div className="section">
        <div className="line line-3"></div>
        <h4 className="section-subtitle">
          <span>2&nbsp;.高效学习路径的规划</span>
        </h4>
        <div className="section-item">
          <div className="div item-text">
            <h3 className="yl-font">如果首次接触爱棋道学习体系</h3>
            <p>
              <strong>先体验：</strong>
              学员可以通过测试获得推荐课程，可免费试听第一节课后，完成付费，就可进入学习中心“我的课程”，进行学习了。
            </p>
            <p>
              <strong>后入学：</strong>
              爱棋道的十二级课程体系，除了给学员教授难度适合的知识点外，每个级别班型匹配对应水平的AI对弈系统
              —“悟空”，让小朋友们始终棋逢对手，不断激发下棋挑战的兴趣。为了实现更好的教学效果，我们需要新学员先通过入学测，再报名暑假班。
            </p>
          </div>
          <div className="item-image">
            <img src="/static/img/promotion/item-5.png" className="img-responsive" alt="item-5" />
          </div>
        </div>
        <div className="section-item">
          <div className="item-image">
            <img src="/static/img/promotion/item-6.png" className="img-responsive" alt="item-6" />
          </div>
          <div className="div item-text-1">
            <h3 className="gn-font">如果已使用爱棋道学习体系</h3>
            <p className="bold">可以按照已完成课程的成绩分布选择</p>
            <p>
              若复习试卷，月测试卷平均分数高于80，建议参加高一级别的课程学习，获得持续进步。(不推荐越级学习，造成局部知识点的学习缺失)
            </p>
            <p className="mb0">
              若平均分数在60-70，建议采用爱棋道“错题本”，反复练习强化弱项学习。同时联系辅导老师进行科学的评估与规划。
            </p>
          </div>
        </div>
        <div className="section-tip">
          <img src="/static/img/promotion/tips.png" className="img-responsive" alt="tips" />
          <p>
            温馨提醒 ：根据实际情况合理规划学习路径，切不可过高或过低地选择课程，影响最终的进步效果
          </p>
        </div>
      </div>

      {/*<div className="section authority cyan">*/}
      {/*  <h4 className="section-subtitle">效果认可度（学生成绩）</h4>*/}
      {/*  <img src="/static/img/promotion/chengji-1.png" className="level-image-box" alt="chengji" />*/}
      {/*  <img src="/static/img/promotion/chengji-2.png" className="level-image-box" alt="chengji" />*/}
      {/*  <img src="/static/img/promotion/chengji-3.png" className="level-image-box" alt="chengji" />*/}
      {/*</div>*/}

      <div
        className="section now"
        style={{ top: "50px", height: "130px", padding: 0, marginBottom: "-20px" }}
      >
        <div
          style={{ bottom: "60px" }}
          onClick={experienceNow}
          className="level-button button-red trial-btn"
        >
          立即体验
        </div>
      </div>

      <div className="right-fixed">
        <div onClick={experienceNow} className="click circle-box trial-btn">
          <span>立即体验</span>
        </div>
        <div className="back-top circle-box" id="backTop" onClick={backTop}>
          <span>回到顶部</span>
        </div>
      </div>
    </div>
  );
}

export default connect(
  function mapStateToProps(state) {
    return (state) => ({
      userInfo: state.common.userInfo,
      igtInfo: state.common.igtInfo,
    });
  },
  function mapDispatchToProps(dispatch) {
    return {};
  }
)(React.memo(LevelIntro));
